import Vue from 'vue';
import Router from 'vue-router';
import SignIn from './views/SignIn.vue';
Vue.use(Router);
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: SignIn,
        },
        {
            path: '/news',
            name: 'news',
            component: SignIn,
        },
        {
            path: '/demo',
            name: 'demo',
            component: SignIn,
        },
        {
            path: '/contact-us',
            name: 'contact-us',
            component: SignIn,
        },
        {
            path: '/sign-in',
            name: 'sign-in',
            component: SignIn,
        },
    ],
});
//# sourceMappingURL=router.js.map